import {Act} from '@gongxigames/framework/slotV2/fsm/acts/Act';
import {consoleLogger} from '@gongxigames/framework/core/fragments/ConsoleLogger';
import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

/**
 * AsyncAct class is used only with AsyncActDecorator.
 */
export class AsyncAct extends Act {
    private _decoratorAct?: AsyncActDecorator;

    protected async executeInternal(): Promise<void> {
        if (this._decoratorAct) {
            consoleLogger.log('>>>>AsyncAct started: ', this._decoratorAct.getName());
            await this._decoratorAct.execute();
            consoleLogger.log('>>>>AsyncAct finished: ', this._decoratorAct.getName());
        }
    }

    public async skip(): Promise<void> {
        if (this._decoratorAct) {
            await this._decoratorAct.skip();
        }
        this.onExecuted?.();
    }

    public async forceSkip(): Promise<void> {
        if (this._decoratorAct) {
            await this._decoratorAct.forceSkip();
        }
    }

    public set decoratorAct(value: AsyncActDecorator) {
        this._decoratorAct = value;
    }

    public removeAllEventListeners(): void {
        this._decoratorAct?.removeAllListeners();
    }
}